
import { Component, Vue, Watch } from "vue-property-decorator";
import { Debounce } from "vue-debounce-decorator";
import centrosAtencionService from "@/services/centros-atencion.service";
import menuService from "@/services/menu.service";
import MobileSectionStrip from "@/components/Common/Web/MobileSectionStrip.vue";

@Component({
  components: {
    MobileSectionStrip
  }
})
export default class Cam extends Vue {
  private mediaUrl = process.env.VUE_APP_MEDIA_URL;
  private menu: any = [];
  private menuLateral: any = [];
  private selected: any = null;
  private verModal: boolean = false;
  private centrosAtencionLoading: boolean = false;
  private centrosAtencionError: string = "";
  private listaCentros: any[] = [];
  private busqueda: any[] | null = null;
  private text: string = "";

  @Watch("text")
  private watchText() {
    this.buscar();
  }

  private mounted() {
    document.title = "Recintos Municipales";
    this.setMenu();
    this.setCentrosAtencion();
  }

  private async setMenu() {
    this.menu = await menuService.getMenu();
    for (let i = 0; i < this.menu.length; i++) {
      if (this.getSubMenu(this.menu[i], "centros-de-atencion-municipal-cam")) {
        this.menuLateral = this.menu[i].sub_menu || [];
        break;
      }
    }
  }

  private getSubMenu(element: any, nombreWeb: string) {
    if (element.nombre_web == nombreWeb) return true;
    if (element.sub_menu && element.sub_menu.length > 0) {
      for (let i = 0; i < element.sub_menu.length; i++) {
        if (this.getSubMenu(element.sub_menu[i], nombreWeb)) return true;
      }
    }
    return false;
  }

  private async setCentrosAtencion() {
    this.centrosAtencionLoading = true;
    this.centrosAtencionError = "";

    try {
      const centros = await centrosAtencionService.getCentrosAtencion();
      this.listaCentros = this.ensureArray(centros)
        .map((centro: any) => ({
          ...centro,
          imagen: this.getImagenUrl(centro.imagen),
          servicios: this.ensureArray(centro.servicios),
          talleres: this.ensureArray(centro.talleres),
          servicios_externos: this.ensureArray(centro.servicios_externos)
        }))
        .sort((a: any, b: any) => a.nombre.localeCompare(b.nombre, "es"));
      this.busqueda = this.listaCentros;
      this.selected = this.busqueda.length > 0 ? this.busqueda[0] : null;
    } catch (error) {
      this.listaCentros = [];
      this.busqueda = null;
      this.selected = null;
      this.centrosAtencionError = "No fue posible cargar los centros de atención.";
    } finally {
      this.centrosAtencionLoading = false;
    }
  }

  private ensureArray(value: any) {
    return Array.isArray(value) ? value : [];
  }

  private getImagenUrl(imagen: string) {
    if (!imagen) {
      return `${this.mediaUrl}/bannerPagina/default.jpg`;
    }

    if (/^https?:\/\//.test(imagen)) {
      return imagen;
    }

    return `${this.mediaUrl}/${String(imagen).replace(/^\/+/, "")}`;
  }

  private getStyle(id: any) {
    if (this.selected && id == this.selected.id) {
      return "border-bottom: 1px solid grey;background-color:#f1f1f1;";
    }

    return "border-bottom: 1px solid grey;";
  }

  private getCenterInfoRows(center: any) {
    return [
      { label: "Dirección", value: center.direccion, icon: "place" },
      { label: "Teléfonos", value: center.telefonos, icon: "phone" },
      { label: "Correo", value: center.correo, icon: "email" },
      { label: "Horario", value: center.horario, icon: "schedule" }
    ].filter(row => row.value && String(row.value).trim() !== "");
  }

  private getContentSections(center: any) {
    return [
      { title: "Servicios", items: this.ensureArray(center.servicios) },
      { title: "Talleres", items: this.ensureArray(center.talleres) },
      {
        title: "Servicios externos",
        items: this.ensureArray(center.servicios_externos)
      }
    ].filter(section => section.items.length > 0);
  }

  @Debounce(500)
  private buscar() {
    const search = this.text.trim().toUpperCase();

    if (search.length > 1) {
      const result = this.listaCentros
        .filter((centro: any) =>
          this.getSearchText(centro).indexOf(search) >= 0
        )
        .sort((a: any, b: any) => a.nombre.localeCompare(b.nombre, "es"));

      this.busqueda = result.length > 0 ? result : null;
      this.selected = this.busqueda ? this.busqueda[0] : null;
    } else {
      this.busqueda = this.listaCentros;
      this.selected = this.busqueda.length > 0 ? this.busqueda[0] : null;
    }
  }

  private getSearchText(centro: any) {
    const values = [
      centro.nombre,
      centro.direccion,
      centro.telefonos,
      centro.correo,
      centro.horario,
      centro.pagina
    ];

    this.getContentSections(centro).forEach(section => {
      section.items.forEach((item: any) => {
        values.push(item.descripcion);
        this.ensureArray(item.operativos).forEach((operativo: any) => {
          values.push(operativo.fecha);
        });
      });
    });

    return values
      .filter(value => value && String(value).trim() !== "")
      .join(" ")
      .toUpperCase();
  }

  private mostrarDatos(id: any) {
    if (!this.busqueda) return;

    for (let i = 0; i < this.busqueda.length; i++) {
      const element = this.busqueda[i];
      if (element.id == id) {
        this.selected = element;
        break;
      }
    }

    if (this.$q.screen.xs || this.$q.screen.sm) {
      this.verModal = true;
    }
  }

  private irLink(link: any) {
    if (link && link != "") {
      window.open(link, "_blank");
    }
  }

  private irMenuItem(item: any) {
    if (item.tipo == 1 || item.tipo == 2) {
      this.irPagina(item.nombre_web);
    } else if (item.tipo == 0) {
      this.toLink(item.url, item.blank);
    }
  }

  private irPagina(nombreWeb: any) {
    if (nombreWeb == "oficinas-y-telefonos-municipales") {
      this.routerGo("Telefonos");
    } else if (nombreWeb == "centros-de-atencion-municipal-cam") {
      this.routerGo("Cam");
    } else {
      this.$router.push({ name: "Pagina", params: { nombre: nombreWeb } });
    }
  }

  private routerGo(name: string) {
    if (this.$router.currentRoute.name == name) {
      this.$router.go(0);
    } else {
      this.$router.push({ name }).catch(err => console.log(err));
    }
  }

  private toLink(url: any, blank: any) {
    if (url && url != "") {
      window.open(url, blank == 1 || blank == "_blank" ? "_blank" : "_self");
    }
  }
}
